export const inverterDefaultValues = {};
